import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { Box, Button, Typography } from '@mui/material';

/**
 * The props for the successful payment component
 */
interface SuccessfulPaymentProps {
  /**
   * A function to handle resetting so that the manager can add more licenses
   */
  reset: () => void;
}

/**
 * The component to show when the payment has been successful
 */
const SuccessfulPayment = (props: SuccessfulPaymentProps) => (
  <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
    <CheckCircleOutlineRoundedIcon color="success" style={{ fontSize: 60 }} />
    <Box display="flex" flexDirection="column" alignItems="center">
      <Typography fontWeight="bold" fontSize="1.5em">
        Payment Successful!
      </Typography>
      <Typography color="textSecondary" textAlign="center">
        Your payment has been successfully received.
      </Typography>
    </Box>
    <Button variant="contained" onClick={props.reset}>
      Add More Licenses
    </Button>
  </Box>
);

export default SuccessfulPayment;
